export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["DRAFT"] = "draft";
    PlanStatus["ACTIVE"] = "active";
    PlanStatus["COMPLETED"] = "completed";
})(PlanStatus || (PlanStatus = {}));
//# sourceMappingURL=plan.enum.js.map